import YYTip from './tip'

export default YYTip